import * as React from 'react'
import analytics from '.'

const Context = React.createContext(null)

export function AnalyticsProvider({ children }) {
  return <Context.Provider value={analytics}>{children}</Context.Provider>
}

export function useAnalytics() {
  return React.useContext(Context)
}
